<template>
  <div class="filter-section section-b-space">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="filter-panel">
            <SearchBrands></SearchBrands>
            <CategoryPanel></CategoryPanel>
            <div class="filters">
              <div class="filter-title">
                <svg class="filter_icon" fill="none">
                  <use xlink:href="#filter_icon" />
                </svg>
                <h6>{{ _T('filter') }}</h6>
              </div>
              <div class="buttons">
                <OrderTypes></OrderTypes>
                <KitchenTypes
                  v-if="getSelectedBusinessTypeShouldHaveKitchen"
                ></KitchenTypes>
                <!--<Locationtypes></Locationtypes>-->
                <PriceDropdown></PriceDropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="mobile-overlay"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchBrands from './SearchBrands'
import CategoryPanel from './CategoryPanel'
import OrderTypes from './OrderTypes'
import KitchenTypes from './KitchenTypes'
// import Locationtypes from './Locationtypes'
import PriceDropdown from './PriceDropdown'

export default {
  name: 'Category',
  components: {
    CategoryPanel,
    OrderTypes,
    KitchenTypes,
    // Locationtypes,
    PriceDropdown,
    SearchBrands,
  },
  data() {
    return {
      swiperOptions: {
        loop: false,
        slidesPerView: 7,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  computed: {
    ...mapGetters([
      'availableOrderTypes',
      '_T',
      'getSelectedBusinessTypeShouldHaveKitchen',
    ]),
  },
}
</script>

<style lang="scss">
.filter-section {
  margin-top: -$px100;
  &.search-store {
    margin-top: -$px50;
  }
  .filter-mobile-title {
    display: none;
  }
  .buttons {
    display: flex;
    .filter-button {
      cursor: pointer;
      position: relative;
      margin-right: 0.9375rem;
      .basic-btn {
        position: relative;
        display: flex;
        border: $px1 solid $light-border;
        background-color: $white;
        padding: $px8 $px15;
        border-radius: $px46;
        .rightarrow {
          width: $px36;
          height: $px22;
          padding-left: $px30;
        }
        h6 {
          font-weight: 600;
          font-size: $px14;
          line-height: $px22;
          text-transform: capitalize;
          letter-spacing: 0.005em;
          color: $font-color;
          margin-bottom: 0;
          max-width: $px100;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: flex;
          span {
            margin-left: $px5;
          }
        }
        &:after {
          content: '';
          position: absolute;
          height: $px20;
          width: $px1;
          right: $px40;
          opacity: 0.5;
          top: 50%;
          transform: translateY(-50%);
          background-color: $light-border;
        }
        .arrow-cls {
          padding-left: $px30;
        }
        .icon {
          margin-right: $px8;
        }
        &.dine-btn {
          background-color: var(--color-primary);
          border: $px1 solid var(--color-primary);
          h6 {
            color: $white;
          }
          &:after {
            background-color: $white;
          }
        }
      }
      + .filter-button {
        //margin-left: $px15;
      }
      .filter-content {
        opacity: 0;
        visibility: hidden;
        position: absolute;
        top: $px55;
        left: 0;
        background-color: $white;
        width: $px400;
        border-radius: $px4;
        border: $px1 solid $light-border;
        padding: $px20 $px16;
        box-shadow: 0px $px14 $px34 rgba($black, 0.1);
        transition: all 0.5s ease;
        z-index: 12;
        &.show {
          opacity: 1;
          visibility: visible;
          top: $px58;
          transition: all 0.5s ease;
        }
        @extend %default-scroll;
        ul {
          max-height: $px180;
          overflow: auto;
          li {
            display: block;
            font-size: $px16;
            line-height: $px19;
            text-transform: capitalize;
            padding: $px20 $px15;
            border-radius: $px4;
            position: relative;
            &:hover {
              background: $light-border;
            }
            &.active {
              color: var(--color-primary);
              border: $px1 solid $light-border;
              &:after {
                content: '';
                position: absolute;
                background-image: url('/images/svg/global/true.svg');
                width: $px20;
                height: $px14;
                right: $px15;
                background-repeat: no-repeat;
              }
            }
          }
        }
        .apply-btn {
          margin-top: $px16;
          text-align: right;
          .btn {
            padding: $px9 $px46;
          }
        }
      }
      &.mobile-filter {
        display: none;
      }
      &.show {
        .filter-content {
          opacity: 1;
          visibility: visible;
          transition: all 0.5s ease;
        }
      }
    }
  }
  .filter-panel {
    padding: $px20;
    background: $white;
    box-shadow: 0px $px4 $px54 rgba($black, 0.07);
    border-radius: $px10;
    position: relative;
    z-index: 2;
    &.pb-0 {
      border-radius: $px10 $px10 0 0;
    }
    .search-bar {
      width: 100%;
      margin-bottom: $px15;
      form {
        display: flex;
        align-items: center;
        .form-group {
          margin-bottom: 0;
          width: calc(100% - 20px);
          position: relative;
          margin-left: 10px;
          border: 1px solid $light-border;
          border-radius: $px10;
          margin-right: 10px;
          transition: box-shadow 0.3s;

          input {
            width: 100%;
            border: $px1 solid $light-border;
            position: absolute;
            &:focus {
              outline: none;
            }
          }
          .location-arrow {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            line-height: 1;
            svg {
              width: $px16;
              height: $px16;
            }
          }
        }
        ::placeholder {
          color: $font-color;
        }
        .form-group:hover {
          box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
        }
        .btn {
          width: 18%;
          margin-left: auto;
          height: $px50;
          span {
            display: none;
          }
        }
      }
      &.search-sm {
        form {
          .form-group {
            input {
              padding: $px10;
              position: absolute;
            }
          }
          .btn {
            height: $px44;
          }
        }
      }
    }
    &.search-auto-service {
    }
    .filters {
      padding-top: $px15;
      margin-top: 0;
      border-top: $px1 solid $light-border;
      display: flex;
      align-items: center;
      .filter-title {
        display: flex;
        align-items: center;
        margin-right: $px28;
        .filter_icon {
          width: $px18;
          height: $px16;
          margin-right: $px10;
        }
        h6 {
          font-weight: 600;
          line-height: $px22;
          text-transform: uppercase;
          margin-bottom: 0;
        }
      }
      .range-slider {
        width: 34.5%;
        margin-left: auto;
        input {
          display: none;
        }
      }
      .range-data {
        margin-left: $px50;
        h6 {
          text-transform: uppercase;
          margin-bottom: 0;
          line-height: $px22;
          letter-spacing: 0.005em;
          font-weight: 600;
        }
      }
    }
  }
  .filter-bottom {
    display: none;
    background-color: $light-border;
    padding: $px30 $px30 $px22 $px30;
    margin-top: -$px8;
    border-radius: $px10;
    .buttons {
      .filter-button {
        margin-left: $px26;
        padding-left: $px26;
        border-left: $px1 solid $dark-border;
        .basic-btn {
          background-color: $transparent;
          padding: 0;
          border: none;
          h6 {
            max-width: 100%;
          }
          .input-group-append {
            display: none;
          }
          ::placeholder {
            font-weight: 600;
            font-size: $px14;
            line-height: $px22;
            text-transform: capitalize;
            letter-spacing: 0.005em;
            color: $font-color;
          }
          input {
            background-color: $transparent;
            border: none;
            padding: 0;
            width: $px105;
            font-weight: 600;
            font-size: $px14;
            line-height: $px22;
            text-transform: capitalize;
            letter-spacing: 0.005em;
            color: $font-color;
            margin-bottom: 0;
            max-width: $px105;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.date-picker {
            .arrow-cls {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
        &:first-child {
          margin-left: 0;
          padding-left: 0;
          border-left: none;
        }
        .basic-btn {
          &:after {
            display: none;
          }
        }
      }
    }
  }
}
@media (max-width: 1199px) {
  .filter-section {
    .buttons {
      .filter-button {
        .filter-content {
          width: $px350;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .filter-section {
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
      width: 0 !important;
    }
    margin-top: -$px50;
    &.search-store {
      margin-top: -$px25;
    }
    .filter-panel {
      .filters {
        width: 100%;
        overflow-x: auto;
        overflow-y: visible;
        .range-slider,
        .range-data {
          display: none;
        }
        .filter-title {
          display: none;
        }
      }
    }
    .buttons {
      width: 100%;
      overflow-x: auto;
      overflow-y: visible;
      .filter-button {
        .basic-btn {
          h6 {
            max-width: 100%;
            overflow: unset;
          }
          .arrow-cls {
            padding-left: $px20;
          }
          &:after {
            right: $px32;
          }
        }
        .filter-content {
          position: fixed;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 6;
          &.show {
            top: 50%;
          }
        }
        .mobile-overlay {
          &.show {
            display: block;
          }
        }
      }
    }
    .mobile-overlay {
      display: none;
      position: fixed;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba($black, 0.5);
      z-index: 5;
      transition: all 0.5s ease;
    }
    .filter-bottom {
      .buttons {
        .filter-button {
          .basic-btn {
            input {
              width: $px120;
              max-width: $px120;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .filter-section {
    margin-top: 0;
    .filter-panel {
      .search-bar {
        form {
          .form-group {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
          }
          .btn {
            display: none;
          }
        }
      }
      .filters {
        margin-top: 0;
        border-top: none;
        &.filter-top-none {
          padding-top: 0;
        }
      }
    }
    .filter-bottom {
      .buttons {
        .filter-button {
          border-left: none;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .filter-section {
    border-top: $px12 solid $light-border;
    .filter-mobile-title {
      display: block;
      text-align: right;
      font-size: $px14;
      padding: $px10 $px20;
      text-transform: capitalize;
      color: $color-primary;
      border-top: $px1 solid $transparent;
      border-bottom: $px1 solid $light-border;
      &.sticky-top {
        position: fixed;
        width: 100%;
        padding: $px10 $px20;
        top: $px84;
        background-color: $white;
        border-top: $px1 solid $light-border;
        border-bottom: $px1 solid $light-border;
        left: 0;
        z-index: 1;
      }
    }
    .filter-panel {
      padding: $px20 0;
      box-shadow: none;
      border-bottom: $px1 solid $light-border;
      border-radius: $px10;
      .responsive-filter {
        display: block;
      }
    }
    .buttons {
      .filter-button {
        .basic-btn {
          border-radius: $px4;
          h6 {
            margin-right: $px10;
          }
          &.dine-btn {
            h6 {
              margin-right: $px10;
            }
          }
        }
        .filter-content {
          padding: 0;
          top: unset;
          bottom: -$px50;
          transform: unset;
          left: 0;
          width: 100vw;
          background-color: $white;
          box-shadow: 0px -$px6 $px30 rgba($black, 0.1);
          display: none;
          animation: fadeInUp;
          animation-duration: 0.5s;
          border-radius: $px4;
          z-index: 10;
          ::-webkit-scrollbar {
            width: $px4 !important;
          }
          ul {
            max-height: $px240;
            overflow: auto;
            margin: $px15;
            padding-right: $px5;
            li {
              border: $px1 solid $light-border;
              border-radius: $px4;
              padding: $px12 $px15;
              display: block;
              position: relative;
              &:after {
                content: '';
                position: absolute;
                background-image: url('/images/svg/global/true-w.svg');
                width: $px22;
                height: $px22;
                right: 0;
                top: 0;
                background-color: $color-primary;
                background-repeat: no-repeat;
                background-position: center;
                border-radius: 0 $px4 0 $px4;
                transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75),
                  -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
                opacity: 0;
                transform: rotate(-45deg) scale(0, 0);
              }
              + li {
                margin-top: $px15;
              }
              &:hover {
                background-color: $transparent;
              }
              &.active {
                border-color: $color-primary;
                &:after {
                  width: $px22;
                  height: $px22;
                  right: 0;
                  top: 0;
                  opacity: 1;
                  background-image: url('/images/svg/global/true-w.svg');
                  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75),
                    -webkit-transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
                  transform: rotate(0) scale(1, 1);
                }
              }
            }
          }
          .content-header {
            padding: $px20 $px16;
            border-bottom: $px1 solid $light-border;
            h6 {
              font-weight: 600;
              font-size: $px18;
              line-height: $px22;
              letter-spacing: 0.02em;
              color: $font-color;
              text-transform: capitalize;
              margin-bottom: 0;
              span {
                font-weight: 600;
                font-size: $px18;
                line-height: $px22;
                letter-spacing: 0.02em;
                color: $light-font;
              }
            }
            .close-filter {
              margin-left: auto;
              padding-top: $px3;
            }
          }
          .content-footer {
            padding: $px15;
            border-top: $px1 solid $light-border;
            display: flex;
            text-transform: capitalize;
            letter-spacing: 0.02em;
            font-weight: 600;
            font-size: $px14;
            line-height: $px17;
            text-align: center;
            .btn {
              width: 46%;
              &.ml-15 {
                margin-left: $px15;
              }
              &.btn-outline {
                color: $light-font;
                border-color: $light-font;
                &:hover {
                  color: $white;
                  background-color: $light-font;
                }
              }
            }
          }
          &.show {
            top: unset;
            bottom: 0;
            display: block;
          }
        }
      }
    }
    .filter-bottom {
      display: none;
    }
    &.filter-classic {
      padding-bottom: 0;
      .filter-panel {
        border-bottom: none;
        padding-bottom: 0;
      }
    }
  }
}
.body-rtl {
  .filter-section {
    .buttons {
      .filter-button {
       margin-left: 0.625rem;
       @media (max-width: 575px) {
          margin-right: unset;
       }
        .basic-btn {
          .rightarrow {
            width: 2.25rem;
            height: 1.1rem;
            padding-top: 0.28rem;
            padding-left: 0;
            padding-right: 19px;
          }
          &:after {
            /*display: none;*/
            left: 2.5rem;
            right: unset;
          }
        }
        .filter-content {
          @media (max-width: 575px) {
            ul { text-align: right;  }
          }
          .content-header {
            .close-filter {
              margin-right: auto;
              margin-left: unset;
            }
          }
        }
      }
    }
    .filter-panel {
      .filters {
        .filter-title {
          .filter_icon {
            margin-left: 0.625rem;
          }
        }
      }
    }
  }
  .filter-menu-section {
    .search-bar {
      margin-right: auto;
      margin-left: unset;
      .form-group {
        img {
          left: 0.9375rem;
          right: unset;
        }
      }
    }
    .filter-menu {
      .filter-list {
        .scrollactive-nav {
          .filter-link {
            svg {
              margin-left: 0.625rem;
            }
          }
        }
      }
    }
  }
}
</style>
